import React from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, theme, useResponsive } from '@sg/garnish';

export const OrderPlaybackTitle = (props: OrderPlaybackTitleProps) => {
  const { title } = props;

  const { minWidth, currentHeight } = useResponsive();
  const withSmallerFont = minWidth.isSM && currentHeight.isSM;
  const fontSize: '16' | '18' = withSmallerFont ? '16' : '18';

  return (
    <BodyText style={styles.text} sizeMatch={[fontSize]}>
      {title}
    </BodyText>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    color: theme.colors.KALE,
  },
});

// ─── Types ─────────────────────────────────────────────────────────────────────

type OrderPlaybackTitleProps = {
  title: string;
};
